import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link,useHistory } from 'react-router-dom';
import SessionManager from "../../utils/authHandling/session-manager";
import { ROLE_VIEW } from "../../config";
import { Button} from 'react-bootstrap';
import { translateLesson, checkTranslationStatus } from "../../server/lessonCall/lesson-call";
import ModalTranslateLesson from '../modalTranslateLesson';
import STATUS from '../../utils/constants/statusConstants';
import {FaEye, FaLanguage, FaFilePdf} from "react-icons/fa";

const LessonTableLinks = ({ lesson }) => {
  const history = useHistory();
  
  const [roles] = useState(() => 
    SessionManager.getSession() !== null ? SessionManager.getSessionDetails().Roles : []
  );
  
  const [status, setStatus] = useState(STATUS.IDLE);
  const [modalShow, setModalShow] = useState(false);
  const [languageSelected, setLanguageSelected] = useState(false);

  const saveLessonId = (id) => {
    sessionStorage.setItem("lastSearch", id);
  };

  const onTranslateLesson = async () => {
    setStatus(STATUS.TRANSLATING);
    try {
        const startResponse = await translateLesson(lesson.id, languageSelected.value); 
        
        const jobId = startResponse.JobId; 

        const finalResult = await pollForCompletion(jobId);

        if (finalResult.Success) {
            saveLessonId(finalResult.Data.LessonId);
            setStatus(STATUS.SUCCESS);
        } else {
          setStatus(STATUS.ERROR);
        }

    } catch (error) {
      setStatus(STATUS.ERROR);
    }
  };

  const pollForCompletion = async (jobId) => {
    while (true) {
        await new Promise(resolve => setTimeout(resolve, 10000));

        const response = await checkTranslationStatus(jobId);

        if (response.status === 202) {
            continue; 
        }

        if (response.status === 200) {
            return response.data;
        }

        setStatus(STATUS.ERROR);
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      {lesson.linkItems.map((item, index) => {
        if (item.linkText) {
          return (
            <Button
              key={`${index}_pdf`}
              as={Link}
              variant="link"
              className="not-so-rounded btn-transparent btn-transparent-danger"
              type="button"
              onClick={() => saveLessonId(item.lessonId)}
              to={{ pathname: "./pdf-viewer", lessonId: item.lessonId }}
            >
              <FaFilePdf/> {item.linkText}
            </Button>
          );
        }

        if (roles.indexOf(ROLE_VIEW) <= -1) {
          return (
            <Button
              key={index}
              as={Link}
              variant="link"
              className="not-so-rounded btn-transparent btn-transparent-primary"
              type="button"
              onClick={() => saveLessonId(item.lessonId)}
              to={{ pathname: item.link, lessonId: item.lessonId }}
            >
              <FaEye/> <FormattedMessage id="lt-view-lesson" />
            </Button>
          );
        }
        return null;
      })}

      {!lesson.title?.includes("AI Translated") && 
        lesson.lessonLangCode?.toLowerCase() === "es" && 
        lesson.subject?.toLowerCase() !== "adl" && 
        lesson.subject?.toLowerCase() !== "sp" && (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <Button
            variant="link"
            className="not-so-rounded btn-transparent btn-transparent-warning"
            type="button"
            onClick={() => setModalShow(true)}
          >
            <FaLanguage/> <FormattedMessage id="lt-translate-lesson" />
          </Button>

          <ModalTranslateLesson
            show={modalShow}
            lessonId={lesson.id}
            lessonLangCode={lesson.lessonLangCode}
            status={status}
            onTranslate={onTranslateLesson}
            languageSelected={languageSelected} 
            onLanguageChange={setLanguageSelected}
            onView={() => history.push("./lesson")}
            onHide={() => setModalShow(false)}
          /></div>)
      }
    </div>
  );
};

export default LessonTableLinks;